<por-base-modal [id]="modalId" [modalWidth]="'modal-md'" [zIndex]="100">
    <div class="default-permissions-modal">
        <div class="default-permissions-modal__header">
            <h2>{{ 'DefaultPermissions.Title' | translate }}</h2>
        </div>

        @if (isLoading) {
        <div class="default-permissions-modal__loading">
            <span porIcon icon="spinner" class="spinner"></span>
        </div>
        } @else {
        <form [formGroup]="permissionsForm" class="default-permissions-modal__form">
            <div class="default-permissions-modal__toggles">
                @for (name of featureNames; track name) {
                <div class="default-permissions-modal__toggle-row">
                    <label class="default-permissions-modal__label">{{ name | translate }}</label>
                    <por-base-toggle [parentForm]="permissionsForm" [formControlName]="name"></por-base-toggle>
                </div>
                }
            </div>

            <div class="default-permissions-modal__footer">
                <por-base-button class="theme-button" type="button" (onclick)="onCancel()">
                    {{ 'DefaultPermissions.Cancel' | translate }}
                </por-base-button>
                <por-base-button class="theme-button" type="button" [disabled]="!loadSucceeded || !hasChanges || isSaving" (onclick)="onSave()">
                    {{ isSaving ? ('DefaultPermissions.Saving' | translate) : ('DefaultPermissions.Save' | translate) }}
                </por-base-button>
            </div>
        </form>
        }
    </div>
</por-base-modal>
